import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { colors } from 'styles/colors';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog';
import { snackbarService } from 'services/snackbarService';
import { getErrorMessage } from 'common/utils';
import { IUser } from 'types/models/User';
import DeleteIcon from 'icons/DeleteIcon';
import { useDeleteVerificationCode } from 'hooks/useVerificationCodes';

interface Props {
  verificationCodeId: string;
  refetch?: () => void;
}

export default function DeleteVerificationCodeActionButton({ refetch, verificationCodeId }: Props) {
  const [open, setOpen] = useState(false);

  const { mutate: deleteMutation, isLoading: isDeleting } = useDeleteVerificationCode(
    (res: any) => {
      refetch?.();
      snackbarService.showSnackbar('Verification code has been deleted successfully', 'success');
      setOpen(false);
    },
    (error: any) => {
      snackbarService.showSnackbar(getErrorMessage(error), 'error');
      setOpen(false);
    }
  );

  const handleConfirm = () => {
    deleteMutation(verificationCodeId);
  };

  return (
    <>
      <Tooltip title={'Delete'}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.error,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.delete,
            },
          }}
        >
          <DeleteIcon color={colors.white} />
        </IconButton>
      </Tooltip>

      <CustomDialog
        open={open}
        title={`${'Delete verification code'}`}
        message={`Are you sure you want to delete this verification code?`}
        buttons={[
          <CustomButton
            key='cancel'
            variant='outlined'
            text='Cancel'
            onClick={() => setOpen(false)}
            disabled={isDeleting}
            height={35}
          />,
          <CustomButton
            key='delete'
            variant='filled'
            color={'error'}
            text={'Delete'}
            onClick={handleConfirm}
            loading={isDeleting}
            height={35}
          />,
        ]}
      />
    </>
  );
}
